/**
 * @generated SignedSource<<898340c3bbea31ee3eac79b2241bd6a5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type productsTable_ProductFragment$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ProductActionColumn_ProductFragment" | "ProductIdColumn_ProductFragment" | "ProductIsHiddenColumn_ProductFragment" | "ProductTitleColumn_ProductFragment" | "ProductTypeColumn_ProductFragment" | "productPriceColumn_ProductFragment">;
  readonly " $fragmentType": "productsTable_ProductFragment";
};
export type productsTable_ProductFragment$key = {
  readonly " $data"?: productsTable_ProductFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"productsTable_ProductFragment">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "productsTable_ProductFragment"
};

(node as any).hash = "e994a40ce15b5be76844cf2941cb52bf";

export default node;
